
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import VModal from 'vue-js-modal';
import Checkmark from '@carbon/icons-vue/es/checkmark/16';
import { ProductColorSetterType } from '@/setters/typings/common/ProductColorsSetterType';
import { ProductPrintVariant } from '@midocean/webapps-shared-domain';
import { CvAccordion, CvAccordionItem } from '@carbon/vue';

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default Vue.extend({
  name: 'SwitchColor',
  components: {
    Checkmark,
    CvAccordion,
    CvAccordionItem,
  },

  props: {
    productVariants: {
      type: [] as PropType<ProductColorSetterType[]>,
      required: true,
    },
  },

  data() {
    return {
      productName: this.productVariants[0].productName,
    };
  },

  computed: {
    ...mapState(useProductStore, [
      'data',
      'isLaserConverter',
      'isDebossingTechnique',
      'getDebossingColor',
    ]),
  },

  methods: {
    ...mapActions(useProductStore, ['setSelectedVariant']),
    ...mapActions(useShapeStore, ['reinitializeShapeVariantImage']),
    changeProductVariantImg(variant: ProductColorSetterType) {
      this.productName = variant.productName;
      let selectedVariant = this.data.variants.find(
        (varImg) => varImg.colour == variant.variantColor
      ) as ProductPrintVariant;

      this.setSelectedVariant(selectedVariant);

      if (this.isLaserConverter() || this.isDebossingTechnique()) {
        let textColor = [255, 255, 255];
        if (this.isDebossingTechnique()) {
          textColor = this.getDebossingColor;
        }
        this.reinitializeShapeVariantImage(selectedVariant, textColor);
      }
    },
  },
});
